import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  CustomButton,
  RegularButton,
} from "../../../common/ReusableComponent/CustomButton";
import AuthContext from "../../../../utils/secure-route/AuthContext";
import ReusableModal from "../../AppPAges/ManageSettings/ReusableModal";
import { ReusableInput } from "../../../common/ReusableComponent//ReusableInput";
import PaginatedSearchSelect from ".././../../common/ReusableComponent/PaginatedSearchSelect/PaginatedSearchSelect";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import AddVendorModal from "../../AppPAges/ReusableForm/AddVendorModal";
import { useToastHandler } from "../../../common/ToastHandler";
import useSwal from "../../../common/ReusableComponent/useSwal";
import AssetTable from "./AssetTable";
import useMyPermissions from "../../../../utils/permissions/useMyPermissions";
import Can from "../../../../utils/permissions/Can";
import { capitalizeFirstLetter } from "../../../../utils/helper/common";
import JsBarcode from "jsbarcode";
import PrintBarcodes from './PrintBarcodes';
import DocumentPreviewModal from '../../../common/ReusableComponent/DocumentPreviewModal';
import { useRef } from "react";
import categoryIcon from "../../../../assets/Image/categoriesLightIcon.png"
import PrintBarcode from "../../../../assets/Image/printbarcodelight.png"
import AddIcon from "../../../../assets/Image/add.png"
import StatusPill from "../../../common/ReusableComponent/StatusPill";
const AssetsInventory = () => {
  const [showModal, setShowModal] = useState(false);
  const { user } = useContext(AuthContext);
  const { can } = useMyPermissions();
  const storeId = user.store;
  const { confirmDelete } = useSwal();
  const { handleToast } = useToastHandler();
  const { GetPaginatedData, Delete, Patch, PostDataForm, getHost } = useApi();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [assetsData, setAssetsData] = useState([]);
  const [editingAsset, setEditingAsset] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [setVendors] = useState([]);

  const [selectedVendorId, setSelectedVendorId] = useState("");
  const [selectedVendorName, setSelectedVendorName] = useState("");
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const [showVendorModal, setShowVendorModal] = useState(false);
  const [barcodeMode, setBarcodeMode] = useState(null);


  const [showAutoBarcodeModal, setShowAutoBarcodeModal] = useState(false);
  const [showManualBarcodeModal, setShowManualBarcodeModal] = useState(false);
  const [selectedAssets, setSelectedAssets] = useState([]);
  const [focusedField, setFocusedField] = useState(null);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [selectedDocumentUrl, setSelectedDocumentUrl] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    category: "",
    description: "",
    vendor: "",
    licence: "",
    warranty: "",
    warranty_start_date: "",
    warranty_end_date: "",
    licence_start_date: "",
    licence_end_date: "",
    upload_pdf_for_referance: "",
    store: "",
    status: "available",
    quantity: 1,
    barcodes: [""],
  });

  const [errors, setErrors] = useState({
    name: "",
    category: "",
    description: "",
    licence: "",
    warranty: "",
  });

  const generateBarcodeValue = (
    assetName,
    categoryName,
    index = 1
  ) => {
    if (!assetName || !categoryName || !user?.store_name) return "";

    const clean = (str) =>
      str.replace(/[^a-zA-Z]/g, "").substring(0, 3).toUpperCase();

    const storeCode = clean(user.store_name);
    const categoryCode = clean(categoryName);
    const assetCode = clean(assetName);

    const sequence = String(index).padStart(4, "0");

    return `${storeCode}${categoryCode}${assetCode}${sequence}`;
  };


  const isValidDuration = (text) => {
    if (!text) return false;
    const lower = text.toLowerCase();
    const hasNumber = /\d/.test(text);
    const hasUnit = lower.includes("year") || lower.includes("month") || lower.includes("day");
    return hasNumber && hasUnit;
  };

  const calculateEndDateFromDuration = (startDate, durationText) => {
    if (!startDate || !durationText) return "";

    const date = new Date(startDate);
    const value = parseInt(durationText);
    if (isNaN(value)) return "";

    const text = durationText.toLowerCase();

    if (text.includes("year")) {
      date.setFullYear(date.getFullYear() + value);
    } else if (text.includes("month")) {
      date.setMonth(date.getMonth() + value);
    } else if (text.includes("day")) {
      date.setDate(date.getDate() + value);
    } else {
      return "";
    }

    return date.toISOString().split("T")[0];
  };


  const handleChange = (e) => {
    const { name, value, files } = e.target;

    let processedValue = value;

    if (
      (name === "name" ||
        name === "description" ||
        name === "licence" ||
        name === "warranty") &&
      !files
    ) {
      processedValue = capitalizeFirstLetter(value);
    }

    setFormData((prev) => {
      const updatedData = {
        ...prev,
        [name]: files ? files[0] : processedValue,
      };

      // WARRANTY AUTO DATES
      if (name === "warranty") {
        if (isValidDuration(processedValue)) {
          const startDate =
            prev.warranty_start_date ||
            new Date().toISOString().split("T")[0];

          updatedData.warranty_start_date = startDate;
          updatedData.warranty_end_date =
            calculateEndDateFromDuration(startDate, processedValue);
        } else {
          updatedData.warranty_start_date = "";
          updatedData.warranty_end_date = "";
        }
      }

      // LICENCE AUTO DATES
      if (name === "licence") {
        if (isValidDuration(processedValue)) {
          const startDate =
            prev.licence_start_date ||
            new Date().toISOString().split("T")[0];

          updatedData.licence_start_date = startDate;
          updatedData.licence_end_date =
            calculateEndDateFromDuration(startDate, processedValue);
        } else {
          updatedData.licence_start_date = "";
          updatedData.licence_end_date = "";
        }
      }
      if (name === "name") {
        // Only generate barcodes if auto mode is selected
        if (barcodeMode === "auto") {
          updatedData.barcodes = Array.from(
            { length: prev.quantity },
            (_, i) =>
              generateBarcodeValue(processedValue, selectedCategoryName, i + 1)
          );
        }
      }
      return updatedData;

    });


    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleModalQuantityChange = (e) => {
    const value = e.target.value;

    // Allow user to clear the field
    if (value === "") {
      setFormData((prev) => ({
        ...prev,
        quantity: "",
        barcodes: []
      }));
      return;
    }

    const qty = Math.max(1, Number(value));

    setFormData((prev) => {
      let barcodes = [];

      if (barcodeMode === "auto") {
        barcodes = Array.from({ length: qty }, (_, i) =>
          generateBarcodeValue(prev.name, selectedCategoryName, i + 1)
        );
      }

      if (barcodeMode === "manual") {
        barcodes = Array.from({ length: qty }, () => "");
      }

      return {
        ...prev,
        quantity: qty,
        barcodes,
      };
    });
  };
  const resetForm = () => {
    setFormData({
      name: "",
      category: "",
      description: "",
      vendor: "",
      licence: "",
      warranty: "",
      warranty_start_date: "",
      warranty_end_date: "",
      licence_start_date: "",
      licence_end_date: "",
      upload_pdf_for_referance: "",
      store: "",
      status: "available",
      quantity: 1,
      barcodes: [""],
    });

    setErrors({
      name: "",
      category: "",
      description: "",
      licence: "",
      warranty: "",
    });

    setSelectedVendorId("");
    setSelectedVendorName("");
    setSelectedCategoryName("");

    setBarcodeMode(null);
    setShowAutoBarcodeModal(false);
    setShowManualBarcodeModal(false);

    setEditingAsset(null);
  };

  const handleCloseModal = () => {
    resetForm();
    setShowModal(false);

  };

  const handleBarcodeChange = (index, value) => {
    setFormData((prev) => {
      const updated = [...prev.barcodes];
      updated[index] = value;
      return { ...prev, barcodes: updated };
    });
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    let error = "";

    if (name === "name") {
      if (!value.trim()) {
        error = "Asset name is required";
      } else if (value.length < 2) {
        error = "Asset name must be at least 2 characters";
      } else if (value.length > 100) {
        error = "Asset name must not exceed 100 characters";
      }
    }

    if (name === "description" && value && value.length > 500) {
      error = "Description must not exceed 500 characters";
    }

    if (name === "licence" && value && value.length > 100) {
      error = "Licence must not exceed 100 characters";
    }

    if (name === "warranty" && value && value.length > 100) {
      error = "Warranty must not exceed 100 characters";
    }

    setErrors({
      ...errors,
      [name]: error,
    });
  };

  const validateForm = () => {
    if (!formData.name.trim()) {
      setErrors((prev) => ({ ...prev, name: "Asset name is required" }));
      return false;
    }
    if (!formData.category.trim()) {
      setErrors((prev) => ({ ...prev, category: "Category is required" }));
      return false;
    }
    return true;
  };

  const fetchAssetList = async ({
    page = 1,
    searchTerm = "",

  } = {}) => {
    try {
      setLoading(true);
      const response = await GetPaginatedData("asset", {
        page,
        search: searchTerm || undefined,

      });

      const results = response?.data || [];
      setAssetsData(results);
      setTotalCount(response?.totalCount || 0);

      const totalCount = response?.totalCount || 0;
      const totalPages = Math.ceil(totalCount / 10);

      return { data: results, totalPages, totalCount, currentPage: page };
    } catch (error) {
      console.error("Fetch error:", error);
      setAssetsData([]);
      handleToast({
        type: "ERROR",
        message: "Failed to fetch assets",
      });

      return { data: [], totalPages: 1, totalCount: 0, currentPage: page };
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    fetchAssetList({ page: currentPage, searchTerm: debouncedSearchTerm });
  }, [currentPage, debouncedSearchTerm, refreshTrigger]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(1);
  };
  const handleAddAssets = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const cleanedBarcodes = formData.barcodes
      .map((b) => b.trim())
      .filter(Boolean);

    const formDataPayload = new FormData();

    formDataPayload.append("name", formData.name.trim());
    formDataPayload.append("category", formData.category);
    formDataPayload.append("description", formData.description.trim());
    formDataPayload.append("vendor", selectedVendorId);
    formDataPayload.append("vendor_name", selectedVendorName);
    formDataPayload.append("licence", formData.licence.trim());
    formDataPayload.append("warranty", formData.warranty.trim());

    if (formData.warranty_start_date) {
      formDataPayload.append("warranty_start_date", formData.warranty_start_date);
    }
    if (formData.warranty_end_date) {
      formDataPayload.append("warranty_end_date", formData.warranty_end_date);
    }
    if (formData.licence_start_date) {
      formDataPayload.append("licence_start_date", formData.licence_start_date);
    }
    if (formData.licence_end_date) {
      formDataPayload.append("licence_end_date", formData.licence_end_date);
    }
    if (formData.upload_pdf_for_referance) {
      formDataPayload.append(
        "upload_pdf_for_referance",
        formData.upload_pdf_for_referance
      );
    }

    formDataPayload.append("quantity", cleanedBarcodes.length);
    formDataPayload.append("barcodes", JSON.stringify(cleanedBarcodes));

    formDataPayload.append("store", storeId);
    formDataPayload.append("status", formData.status);

    const apiCall = editingAsset
      ? Patch("asset", editingAsset.id, formDataPayload)
      : PostDataForm("asset", formDataPayload);

    try {
      const response = await apiCall;

      handleToast({
        type: "SUCCESS",
        message: response?.data?.message ||
          `Asset ${editingAsset ? "updated" : "added"} successfully`,
      });
      resetForm();
      setShowModal(false);

      setRefreshTrigger((prev) => prev + 1);
    } catch (error) {
      const apiMessage =
        error?.response?.data?.detail ||
        "Failed to save asset";

      const duplicateBarcodes =
        error?.response?.data?.barcodes?.length
          ? `Duplicate barcodes: ${error.response.data.barcodes.join(", ")}`
          : "";

      handleToast({
        type: "ERROR",
        message: duplicateBarcodes
          ? `${apiMessage}. ${duplicateBarcodes}`
          : apiMessage,
      });
    }
  };


  const handleEditAsset = (assetIdOrObject) => {
    let assetObject;

    if (typeof assetIdOrObject === "string") {
      assetObject = assetsData.find((item) => item.id === assetIdOrObject);
    } else if (assetIdOrObject && typeof assetIdOrObject === "object") {
      assetObject = assetIdOrObject;
    }

    if (!assetObject || !assetObject.id) {
      handleToast({
        type: "ERROR",
        message: "Cannot edit: Invalid item selected",
      });
      return;
    }

    setEditingAsset({ ...assetObject });

    const existingBarcodes = assetObject.barcodes || (assetObject.barcode ? [assetObject.barcode] : [""]);

    setFormData({
      name: assetObject.name || "",
      category: assetObject.category || "",
      description: assetObject.description || "",
      vendor: assetObject.vendor || "",
      licence: assetObject.licence || "",
      warranty: assetObject.warranty || "",
      warranty_start_date: assetObject.warranty_start_date || "",
      warranty_end_date: assetObject.warranty_end_date || "",
      licence_start_date: assetObject.licence_start_date || "",
      licence_end_date: assetObject.licence_end_date || "",
      upload_pdf_for_referance: "",
      store: assetObject.store || storeId,
      status: assetObject.status || "available",
      quantity: existingBarcodes.length,
      barcodes: existingBarcodes,
    });


    if (existingBarcodes.length > 0 && existingBarcodes[0]) {
      setBarcodeMode("manual");
    }

    setSelectedVendorId(assetObject.vendor || "");
    setSelectedVendorName(assetObject.vendor_name || "");
    setSelectedCategoryName(assetObject.category_name || "");
    setShowModal(true);
  };

  const handleDeleteAsset = async (assetIdOrObject) => {
    const id =
      typeof assetIdOrObject === "string"
        ? assetIdOrObject
        : assetIdOrObject?.id;

    if (!id) {
      handleToast({
        type: "ERROR",
        message: "Cannot delete: Invalid item selected",
      });
      return;
    }

    const result = await confirmDelete(
      "Are you sure?",
      "You won't be able to revert this!"
    );

    if (!result.isConfirmed) return;

    try {
      await Delete("asset", id);
      handleToast({
        type: "SUCCESS",
        message: "Asset deleted successfully",
      });
      setRefreshTrigger((prev) => prev + 1);
    } catch (error) {
      handleToast({
        type: "ERROR",
        message: "Failed to delete asset",
      });
    }
  };



  const handleCloseVendorModal = () => setShowVendorModal(false);

  const handleVendorAdded = (newVendor) => {
    setVendors((prev) => [...prev, newVendor]);
    setSelectedVendorId(newVendor.id);
    setSelectedVendorName(newVendor.name);
  };

  const updateVendors = (newVendor) => {
    setVendors((prev) => [...prev, newVendor]);
  };

  const resetBarcodeForm = () => {
    setBarcodeMode(null);
    setShowAutoBarcodeModal(false);
    setShowManualBarcodeModal(false);

    setFormData((prev) => ({
      ...prev,
      quantity: 1,
      barcodes: [""],
    }));
  };

  const handleDocumentView = (url) => {

    const fullUrl = url.startsWith('http') ? url : getHost() + url;
    setSelectedDocumentUrl(fullUrl);
    setShowDocumentModal(true);
  };

  const handleSelectAsset = (assetId) => {
    setSelectedAssets((prev) =>
      prev.includes(assetId)
        ? prev.filter((id) => id !== assetId)
        : [...prev, assetId]
    );
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedAssets(assetsData.map((asset) => asset.id));
    } else {
      setSelectedAssets([]);
    }
  };

  const printBarcodesComponent = PrintBarcodes({ selectedAssets, assetsData, handleToast });
  const { handlePrintBarcodes } = printBarcodesComponent;

  const BarcodePreview = ({ value }) => {
    const canvasRef = useRef(null);

    useEffect(() => {
      if (value && canvasRef.current) {
        JsBarcode(canvasRef.current, value, {
          format: "CODE128",
          width: 2,
          height: 40,
          displayValue: true,
          margin: 5,
        });
      }
    }, [value]);

    return (
      <canvas
        ref={canvasRef}
        style={{
          cursor: "pointer",
          border: "1px solid #ddd",
          padding: "4px",
          background: "#fff",
        }}
      />
    );
  };

  const ASSET_STATUS_PILL = {
    available: {
      bg: "#e9fdf3",
      text: "#12b76a",
      border: "#a6f4c5",
    },
    "in use": {
      bg: "#fff7ed",
      text: "#ea580c",
      border: "#fed7aa",
    },
    "under maintenance": {
      bg: "#fdecec",
      text: "#e11d48",
      border: "#fda4af",
    },
    retired: {
      bg: "#f1f3f5",
      text: "#6c757d",
      border: "#ced4da",
    },
  };

  const columns = [
    {
      header: (
        <input
          type="checkbox"
          onChange={handleSelectAll}
          checked={selectedAssets.length === assetsData.length && assetsData.length > 0}
          style={{ transform: "scale(1.3)", cursor: "pointer" }}
        />
      ),
      field: "select",
      render: (row) => (
        <input
          type="checkbox"
          checked={selectedAssets.includes(row.id)}
          onChange={() => handleSelectAsset(row.id)}
          style={{ transform: "scale(1.3)", cursor: "pointer" }}
        />
      ),
    },
    { header: "Name", field: "name" },
    { header: "Category", field: "category_name" },
    { header: "Description", field: "description" },
    { header: "Barcode", field: "barcode" },
    { header: "Vendor", field: "vendor_name" },
    // {
    //   header: "Document",
    //   field: "upload_pdf_for_referance",
    //   render: (row) => {
    //     if (row.upload_pdf_for_referance) {
    //       return (
    //         <button
    //           onClick={() => handleDocumentView(row.upload_pdf_for_referance)}
    //           style={{
    //             backgroundColor: "#007bff",
    //             color: "white",
    //             border: "none",
    //             padding: "4px 8px",
    //             borderRadius: "4px",
    //             cursor: "pointer",
    //             fontSize: "12px"
    //           }}
    //         >
    //           View PDF
    //         </button>
    //       );
    //     }
    //     return "-";
    //   }
    // },
    {
      header: "Status",
      render: (row) => {
        const status = row.status || "available";
        const cfg = ASSET_STATUS_PILL[status] || ASSET_STATUS_PILL.available;

        return (
          <StatusPill
            label={status}
            bgColor={cfg.bg}
            textColor={cfg.text}
            borderColor={cfg.border}
          />
        );
      }
    }

  ];
  return (
    <>
      <div className="responsive-box">
        <div className="inventory-header">
          <div className="inventory-title">Assets Inventory</div>
          <div
            className="btn-position"
            style={{ display: "flex", gap: "10px" }}
          >
            <CustomButton
              text="Add Category"
              icon={categoryIcon}
              onClick={() => navigate("/asset-category")}
              color="#FFFFFF"
              backgroundColor="#4a5546"
              iconPosition="right"
            />


            <CustomButton
              text="Print Barcode"
              icon={PrintBarcode}
              onClick={() => {
                if (selectedAssets.length === 0) {
                  handleToast({
                    type: "ERROR",
                    message: "Please select product first",
                  });
                  return;
                }
                handlePrintBarcodes();
              }}
              color="#FFFFFF"
              backgroundColor="#4a5546"
              iconPosition="right"
            />

            <Can module="assetService" action="add">
              <CustomButton
                text="Add Assets"
                icon={AddIcon}
                onClick={() => setShowModal(true)}
                color="#000000"
                backgroundColor="#FFAF32"
                iconPosition="right"
              />
            </Can>
          </div>

          <ReusableModal
            title={`${editingAsset ? "Edit" : "Add"} Assets`}
            show={showModal}
            handleClose={handleCloseModal}
            width="800px"
            height="590px"
          >
            <form onSubmit={handleAddAssets}>
              <div
                className="d-flex flex-column"
                style={{
                  marginLeft: "0px",
                  marginRight: "0px",
                }}
              >
                <div className="d-flex align-items-center  mx-3">
                  <ReusableInput
                    type="text"
                    name="name"
                    label="Name"
                    value={formData.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required
                    maxLength={100}
                    error={errors.name}
                  />
                  <ReusableInput
                    type="text"
                    name="description"
                    label="Description"
                    value={formData.description}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    maxLength={500}
                    error={errors.description}
                  />

                </div>
                <div className="d-flex align-items-start mb-4 mx-3">
                  <div className="d-flex flex-column" style={{ width: "450px" }}>
                    <PaginatedSearchSelect
                      api="category"
                      GetPaginatedData={GetPaginatedData}
                      style={{ width: "360px" }}
                      getOptionLabel={(opt) => opt.category_name}

                      onSelect={(opt) => {
                        const categoryName = opt?.category_name || "";

                        setSelectedCategoryName(categoryName);

                        setFormData((prev) => {
                          const updatedData = {
                            ...prev,
                            category: opt?.id || "",
                          };

                          if (barcodeMode === "auto") {
                            updatedData.barcodes = Array.from(
                              { length: prev.quantity },
                              (_, i) =>
                                generateBarcodeValue(prev.name, categoryName, i + 1)
                            );
                          }

                          return updatedData;
                        });

                        if (errors.category) {
                          setErrors((prev) => ({ ...prev, category: "" }));
                        }
                      }}

                      placeholder="Select Category *"
                      pageSize={10}
                      value={
                        formData.category && selectedCategoryName
                          ? {
                            id: formData.category,
                            category_name: selectedCategoryName,
                          }
                          : null
                      }
                      required
                      error={errors.category}
                    />
                    {errors.category && (
                      <div className="text-danger" style={{ fontSize: "12px", marginTop: "4px" }}>
                        {errors.category}
                      </div>
                    )}
                  </div>

                  <PaginatedSearchSelect
                    api="vendorDepartmentData"
                    GetPaginatedData={GetPaginatedData}
                    style={{ width: "500px" }}
                    getOptionLabel={(opt) => opt.name}
                    onSelect={(opt) => {
                      if (opt?.id === "add-vendor") {
                        setShowVendorModal(true);
                      } else {
                        setSelectedVendorId(opt?.id || "");
                        setSelectedVendorName(opt?.name || "");
                        setFormData((prev) => ({
                          ...prev,
                          vendor: opt?.id || "",
                        }));
                      }
                    }}
                    placeholder="Select Vendor"
                    pageSize={10}
                    value={
                      selectedVendorId
                        ? { id: selectedVendorId, name: selectedVendorName }
                        : null
                    }
                    filterFn={(vendor) =>
                      vendor.type === "expense" && !vendor.is_deleted
                    }
                    extraOptions={[{ id: "add-vendor", label: "Add Vendor" }]}
                  />
                </div>
                <div className="d-flex align-items-center mb-2 mx-3 mt-2">

                  <ReusableInput
                    type="text"
                    name="warranty"
                    label="Warranty"
                    value={formData.warranty}
                    onChange={handleChange}
                    onBlur={(e) => {
                      handleBlur(e);
                      setFocusedField(null);
                    }}
                    onFocus={() => setFocusedField("warranty")}
                    maxLength={100}
                    placeholder={focusedField === "warranty" ? "e.g 12 Days, 6 Month, 1 Year or 0" : ""}
                    error={errors.warranty}
                  />
                  <ReusableInput
                    type="date"
                    name="warranty_start_date"
                    label="Warranty Start Date"
                    value={formData.warranty_start_date}
                    onChange={handleChange}
                    disabled={isValidDuration(formData.warranty)}
                  />

                  <ReusableInput
                    type="date"
                    name="warranty_end_date"
                    label="Warranty End Date"
                    value={formData.warranty_end_date}
                    onChange={handleChange}
                    disabled={isValidDuration(formData.warranty)}
                  />
                </div>
                <div className="d-flex align-items-center mb-4 mx-3">

                  <ReusableInput
                    type="text"
                    name="licence"
                    label="Licence"
                    value={formData.licence}
                    onChange={handleChange}
                    onBlur={(e) => {
                      handleBlur(e);
                      setFocusedField(null);
                    }}
                    onFocus={() => setFocusedField("licence")}
                    maxLength={100}
                    placeholder={focusedField === "licence" ? "e.g 12 Days, 6 Month, 1 Year or 0" : ""}
                    error={errors.licence}
                  />
                  <ReusableInput
                    type="date"
                    name="licence_start_date"
                    label="Licence Start Date"
                    value={formData.licence_start_date}
                    onChange={handleChange}
                    disabled={isValidDuration(formData.licence)}
                  />

                  <ReusableInput
                    type="date"
                    name="licence_end_date"
                    label="Licence End Date"
                    value={formData.licence_end_date}
                    onChange={handleChange}
                    disabled={isValidDuration(formData.licence)}
                  />
                </div>


                <div className="d-flex align-items-center mb-4 mx-3">

                  <ReusableInput
                    type="file"
                    name="upload_pdf_for_referance"
                    label="Upload PDF Reference"
                    onChange={handleChange}
                  />

                </div>
                <div className="d-flex align-items-start gap-3 mx-3">
                  <label>
                    <input
                      type="checkbox"
                      checked={barcodeMode === "auto"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setBarcodeMode("auto");
                          // Generate initial barcodes when auto mode is selected
                          if (formData.name && selectedCategoryName) {
                            setFormData((prev) => ({
                              ...prev,
                              barcodes: Array.from(
                                { length: prev.quantity },
                                (_, i) =>
                                  generateBarcodeValue(prev.name, selectedCategoryName, i + 1)
                              ),
                            }));
                          }
                          setShowAutoBarcodeModal(true);
                        } else {
                          setBarcodeMode(null);
                        }
                      }}
                      style={{
                        transform: "scale(1.5)",
                        accentColor: "black",
                        marginRight: "8px",
                      }}
                    />
                    Generate Barcode
                  </label>

                  <label>
                    <input
                      type="checkbox"
                      checked={barcodeMode === "manual"}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setBarcodeMode("manual");
                          setShowManualBarcodeModal(true);
                        } else {
                          setBarcodeMode(null);
                        }
                      }} style={{
                        transform: "scale(1.5)",
                        accentColor: "black",
                        marginRight: "8px",
                      }}
                    />
                    Enter Barcode Manually
                  </label>
                </div>

                {/* Show existing barcodes in edit mode */}
                {editingAsset && formData.barcodes && formData.barcodes.length > 0 && formData.barcodes[0] && (
                  <div className="mx-3 mt-3">
                    <h6>Current Barcode:</h6>
                    <div style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                      gap: "12px",
                      marginBottom: "12px"
                    }}>
                      {formData.barcodes.map((barcode, index) => (
                        barcode && (
                          <div className="mt-3" key={index}>
                            <ReusableInput
                              type="text"
                              label={`Barcode ${index + 1}`}
                              value={barcode}
                              onChange={(e) => handleBarcodeChange(index, e.target.value)}
                            />
                            <div style={{ textAlign: "center", marginTop: "8px" }}>
                              <BarcodePreview value={barcode} />
                            </div>
                          </div>
                        )
                      ))}
                    </div>
                  </div>
                )}

                <div className="d-flex justify-content-end mt-1 mx-3">
                  {!editingAsset && (
                    <RegularButton
                      text="Clear"
                      onClick={resetForm}
                      backgroundColor="#ffffff"
                      color="#282E26"
                    />
                  )}
                  <RegularButton
                    text={editingAsset ? "Update" : "Save"}
                    type="submit"
                    backgroundColor="#282e26"
                  />
                </div>
              </div>
            </form>
            <ReusableModal
              title="Auto Generated Barcodes"
              show={showAutoBarcodeModal}
              handleClose={resetBarcodeForm}
              width="650px"
            >
              <ReusableInput
                type="number"
                label="Quantity"
                min={1}
                value={formData.quantity || ""}
                onChange={handleModalQuantityChange}
              />

              <div style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "12px",
                marginBottom: "12px"
              }}>
                {(formData.barcodes || []).map((barcode, index) => (
                  <div key={index}>
                    <ReusableInput
                      type="text"
                      label={`Barcode ${index + 1}`}
                      value={barcode}
                      disabled
                    />
                    {barcode && <BarcodePreview value={barcode} />}
                  </div>
                ))}
              </div>

              <RegularButton
                text={"Save"}
                type="submit"
                onClick={handleAddAssets}
                backgroundColor="#282e26"
              />

            </ReusableModal>
            <ReusableModal
              title="Enter Barcodes Manually"
              show={showManualBarcodeModal}
              handleClose={resetBarcodeForm}
              width="600px"
            >
              <ReusableInput
                type="number"
                label="Quantity"
                min={1}
                value={formData.quantity || ""}
                onChange={handleModalQuantityChange}
              />
              <div style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "12px"
              }}>
                {(formData.barcodes || []).map((barcode, index) => (
                  <ReusableInput
                    key={index}
                    type="text"
                    label={`Barcode ${index + 1}`}
                    value={barcode}
                    onChange={(e) =>
                      handleBarcodeChange(index, e.target.value)
                    }
                    required
                  />
                ))}
              </div>
              <RegularButton
                text={"Save"}
                type="submit"
                onClick={handleAddAssets}
                backgroundColor="#282e26"
              />
            </ReusableModal>

          </ReusableModal>
        </div>

        <AssetTable
          data={assetsData}
          columns={columns}
          loading={loading}
          showAction={true}
          onEdit={can("assetService", "change") ? handleEditAsset : undefined}
          onDelete={can("assetService", "delete") ? handleDeleteAsset : undefined}
          showFooter
          currentPage={currentPage}
          totalCount={totalCount}
          onPageChange={handlePageChange}
          searchTerm={searchTerm}
          onSearch={handleSearch}
        />

        <AddVendorModal
          show={showVendorModal}
          handleClose={handleCloseVendorModal}
          onVendorAdded={handleVendorAdded}
          updateVendors={updateVendors}
        />

        <DocumentPreviewModal
          isOpen={showDocumentModal}
          onClose={() => setShowDocumentModal(false)}
          fileUrl={selectedDocumentUrl}
        />
      </div>
    </>
  );
};

export default AssetsInventory;
